import React from 'react';
import { connect } from 'react-redux';
import { maxBy, isEqual } from 'lodash';
import ReactTable from "react-table";
import CSV from '../../../helpers/CSVExport';
import ReactSelect from '../../common/ReactSelect';

import config from '../../../config/config';
import Box from '../../common/Box';
var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');
import { statsActions } from '../../../data/actions/stats';
import { BarChart, LineChart} from '../../widgets/charts/types';
import { splitByThousands } from '../../../helpers/NumberFormatter';

class IncomeChart extends React.Component {
	
	constructor(props) {
		super(props);
		this.exportToCsv = this.exportToCsv.bind(this);        
	}
	
	exportToCsv(){
		const { tracks, id }  = this.props,
			exportData = tracks.demographicsComparison[id].data;        
		const filename = CSV.CSVHeader(`track-comparison-demographics`, id);
		return CSV.CSVExport(exportData, {filename}, 'track-comparison-demographics');
	}

	renderToolbar(){
		let toolbar = [];
		toolbar.push(<div key="wrapper" className="ibox-action-holder">
		<div className="ibox-actions">
		  <a key="download" title="Export CSV" onClick={this.exportToCsv} className="chart-icon download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
		</div>
		</div>)
		return toolbar;
	}


	componentDidMount() {
		const { entities } = this.props
		this.props.dispatch(statsActions.compareEntitiesIncome(entities))
		
	}
	
	componentWillReceiveProps(nextProps) {		
		if(nextProps.entities){
			if(this.props.entities!==undefined && !isEqual(nextProps.entities, this.props.entities)) {
				this.props.dispatch(statsActions.compareEntitiesIncome(nextProps.entities))
			}                
		}

	}
	
	render (){
		const { entitiesIncome: chartData, entitiesIncomeLoading } = this.props.stats;
		
		return <Box title="" spinnerEnabled={entitiesIncomeLoading} toolbar={this.renderToolbar()}>
		
			{chartData && <div className="row">
				<div className={`col-xs-12`}>
					{chartData.datasets.length > 0 && <div className="chart-block">
						<LineChart data={chartData} id={'sales'} options={{
						}} />                          
					</div>}
					{!chartData.datasets.length && <p>No data available</p>}
				</div>    
			</div>}
		</Box>
	}
}

function mapStateToProps(state) {
	return {
		stats: state.stats,
	} 
}

export default connect(mapStateToProps)(IncomeChart);